<template>
  <div class="w-100">
    <div
      v-if="file && !isLoading"
      class="border justify-content-between rounded border-light mt-3 cursor-pointer w-100">
      <div class="d-flex justify-content-end position-relative">
        <div class="bg-light position-absolute" style="border-radius: 0 3px 0 3px; top: 0; right: 0">
          <b-dropdown
            size="sm"
            toggle-class="btn-rounded-2 text-decoration-none bg-light border-0"
            variant="light"
            no-caret
          >
            <template #button-content>
              <i class="bx bx-dots-vertical text-semi-light"/>
            </template>
            <b-dropdown-item-button
              v-if="file.user === userMe && file.type === 'document'"
              @click="$emit('clickRename', file)"
            >
              <div class="d-flex align-items-center">
                <i class="bx bx-edit-alt mr-1"/>
                <div>Renommer</div>
              </div>
            </b-dropdown-item-button>
            <b-dropdown-item-button>
              <div
                v-if="file.user === userMe"
                class="d-flex align-items-center"
                @click="$emit('clickDelete', file)"
              >
                <i class="bx bx-trash-alt mr-1"/>
                <div>Supprimer</div>
              </div>
            </b-dropdown-item-button>
            <b-dropdown-item-button
              v-if="file.user === userMe"
              @click="$emit('clickShare', file)"
            >
              <div class="d-flex align-items-center">
                <i class="bx bx-user-plus mr-1"/>
                <div>Partager</div>
              </div>
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="$emit('clickFavorite', file)">
              <div class="d-flex align-items-center">
                <i v-if="favorite" class="mdi mdi-star text-warning mr-1"/>
                <i v-else class="mdi mdi-star-outline text-warning mr-1"/>
                <div>
                  {{ favorite ? 'Retirer des favoris' : 'Ajouter aux favoris' }}
                </div>
              </div>
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
      </div>
      <div class="d-flex justify-content-center my-4" @click="openFile">
        <i v-if="file.type === 'document'" class="bx bx-file text-primary bx-md"/>
        <i v-if="file.type === 'note'" class="mdi mdi-clipboard-text-outline text-primary bx-md"/>
      </div>
      <div class="bg-light d-flex justify-content-center py-2" @click="openFile">
        <h6
          class="m-0 p-0 px-2 text-semi-light w-100"
          style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
          {{ file.name }}
        </h6>
      </div>
    </div>
    <div v-if="isLoading">
      <vue-content-loading :height="300" class="mb-3 w-100">
        <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%"/>
      </vue-content-loading>
    </div>
  </div>
</template>

<script>

import VueContentLoading from 'vue-content-loading'

export default {
  name: "file",

  components: {
    VueContentLoading,
  },

  props: {
    file: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
    userMe: {
      type: String,
      default: '',
    },
  },

  computed: {
    favorite() {
      return this.file.favorite_users.find(u => u === this.userMe)
    },
  },

  methods: {
    openFile() {
      if (this.file.type === 'note') {
        this.$emit('clickNote', this.file)
      } else {
        window.open(this.file.document, '_blank')
      }
    },
  },
}
</script>

<style scoped>

</style>